export default __webpack_public_path__ + "static/media/O-146.22c0cef5.png";